import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export default function DocsObligatoiresBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [pbs, setPbs] = useState([]);
  useEffect(() => {
    if (!user || !user.food_truck_id) return;
    (async () => {
      try {
        const r = await axios.get(`${API_URL}/kpis-performance/mes-documents`, { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });
        setPbs((r.data && r.data.problemes) || []);
      } catch (e) {}
    })();
  }, [user]);
  if (!pbs.length) return null;
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4">
      <div className="font-medium text-amber-900">Documents obligatoires a mettre a jour ({pbs.length})</div>
      <ul className="mt-1 text-sm text-amber-800 list-disc list-inside">
        {pbs.map((p, i) => (<li key={i}>{p.label} — {p.statut === "perime" ? "perime" : p.statut === "bientot" ? "expire bientot" : p.statut === "sans_date" ? "date manquante" : "manquant"}</li>))}
      </ul>
      <button onClick={() => navigate("/mon-food-truck?tab=documents")} className="mt-3 bg-primary hover:bg-primary/90 text-white text-sm px-4 py-2 rounded-md">
        Deposer mes documents
      </button>
    </div>
  );
}
